import React, { useState, useEffect } from 'react';

export function LogoWidget() {

  return (
    <div style={{width: "100%", height: "100%"}} className="">
        <img style={{width: "100%", height: "100%"}} src='./FlavoriaLabel.svg'/>
    </div>
  );
}